import * as React from "react";
const footerTemplate = (props) => {
  return (   

        <div className="row" style={{ position: "relative", border:"1px solid #494a48", width: "98%", margin:"0 auto"}}>
          <div className="col-md-4" style={{ padding:"10px", border:"1px solid #494a48", color: "#000", backgroundColor: "#b0e84f"}}>Team Sport Science</div>
          <div className="col-md-8" style={{ padding:"10px", color:"blue"}}>Tarun Sardesai Golf Pvt. Ltd.</div>
        </div>
  );
};
export default footerTemplate;